
import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Button, CardBody, Card, CardTitle, Alert } from 'reactstrap'
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa'
import {
  setStatus
} from '../../../actions/adminActions'
import { withRouter } from 'react-router'
import PropTypes from 'prop-types'

class RejectAccept extends Component {
  render () {
    return (
      <Card>
        <CardTitle>Decision</CardTitle>
        <CardBody>
          {this.props.status === 'accepted' || this.props.status === 'rejected'
            ? <Alert className='cap-fl' color={`${this.props.status === 'rejected' ? 'danger' : 'success'}`}>{this.props.status}</Alert>
            : <div>
              <Button className='ml-1 mr-1' onClick={() => { this.props.setStatus('accepted', true) }} color='secondary'><FaCheckCircle /> Accept</Button>
              <Button className='ml-1 mr-1' onClick={() => { this.props.setStatus('rejected', true) }} color='secondary'><FaTimesCircle /> Reject</Button>
            </div>
          }
        </CardBody>
      </Card>
    )
  }
}

RejectAccept.propTypes = {
  setStatus: PropTypes.func,
  status: PropTypes.string
}

const mapStateToProps = ({ admin }) => ({
  setStatus
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setStatus
    },
    dispatch)

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(RejectAccept))



// WEBPACK FOOTER //
// ./src/containers/admin/AdminAppeal/_RejectAccept.jsx